import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca23cc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5 min-vh-50" }
const _hoisted_2 = { class: "contacts-container" }
const _hoisted_3 = { class: "contacts-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "contacts-icon" }, "✍️", -1))
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("️ ")
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 col-md-6 text-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "me-3"
}, "*", -1))
const _hoisted_10 = { class: "col-12 col-md-6 text-end" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "me-3"
}, "*", -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 text-end" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "object",
  class: "me-3"
}, "*", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: ""
}, "Scegli l'oggetto", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Merchandise", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Esperienze", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Info generali", -1))
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 text-end" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "me-3"
}, "*", -1))
const _hoisted_23 = { class: "row mt-5" }
const _hoisted_24 = { class: "col-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "privacy",
  hidden: ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-11" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Ho letto l'informativa inerente la "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.iubenda.com/privacy-policy/19232192",
      target: "_blank"
    }, "Privacy Policy"),
    /*#__PURE__*/_createTextVNode(" e acconsento alla registrazione.")
  ])
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-pc btn-pc-secondary"
    }, "Invia")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.contacts')), 1),
      _hoisted_4,
      _createElementVNode("p", {
        class: "contacts-subtitle",
        innerHTML: _ctx.$t('common.contactssubtitle')
      }, null, 8, _hoisted_5),
      _hoisted_6,
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              name: "name",
              class: _normalizeClass(["form-control", $setup.status($setup.v.name)]),
              placeholder: "Nome",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v.name.$model) = $event))
            }, null, 2), [
              [_vModelText, $setup.v.name.$model]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              name: "email",
              class: _normalizeClass(["form-control", $setup.status($setup.v.email)]),
              placeholder: "E-mail",
              "aria-label": "E-mail",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.v.email.$model) = $event))
            }, null, 2), [
              [_vModelText, $setup.v.email.$model]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("select", {
              id: "object",
              name: "object",
              class: _normalizeClass(["form-select", $setup.status($setup.v.type)]),
              placeholder: "Nome",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.v.type.$model) = $event))
            }, _hoisted_19, 2), [
              [_vModelSelect, $setup.v.type.$model]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _withDirectives(_createElementVNode("textarea", {
              rows: "10",
              id: "message",
              name: "message",
              class: _normalizeClass(["form-control", $setup.status($setup.v.notes)]),
              placeholder: "Messaggio",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.v.notes.$model) = $event))
            }, null, 2), [
              [_vModelText, $setup.v.notes.$model]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "privacy",
              name: "privacy",
              class: _normalizeClass(["form-check-input", $setup.status($setup.v.privacy)]),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.v.privacy.$model) = $event))
            }, null, 2), [
              [_vModelCheckbox, $setup.v.privacy.$model]
            ])
          ]),
          _hoisted_26
        ]),
        _hoisted_27
      ], 32)
    ])
  ]))
}